import React from 'react';
import LiveStreamHeroSection from '@/components/hiveshare-live/LiveStreamHeroSection';
import LiveStreamRevShare from '@/components/hiveshare-live/LiveStreamRevShare';
import LiveStreamFeatures from '@/components/hiveshare-live/LiveStreamFeatures';
import LiveStreamPricing from '@/components/hiveshare-live/LiveStreamPricing';
import LiveStreamTestimonials from '@/components/hiveshare-live/LiveStreamTestimonials';
import LiveStreamDemo from '@/components/hiveshare-live/LiveStreamDemo';
import LiveStreamFAQ from '@/components/hiveshare-live/LiveStreamFAQ';
import LiveStreamCTA from '@/components/hiveshare-live/LiveStreamCTA';

const HiveShareLive = () => {
  return (
    <div className="min-h-screen bg-white">
      <LiveStreamHeroSection />
      <LiveStreamRevShare />
      <LiveStreamFeatures />
      <LiveStreamPricing />
      <LiveStreamTestimonials />
      <LiveStreamDemo />
      <LiveStreamFAQ />
      <LiveStreamCTA />
    </div>
  );
};

export default HiveShareLive;